import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { Badge, Box } from '@mui/material';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';

import '../../scss/_variables.scss';
import { FilteredMenuItems } from '../../sidebarPerms';
import { SidebarMenuItems } from '../../menuItems';
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked, faCalendars } from '@fortawesome/pro-light-svg-icons';
import { faTableColumns } from '@fortawesome/pro-regular-svg-icons';

const NewSidebar = () => {
  const { collapseSidebar, toggleSidebar, toggled } = useProSidebar();
  const menuItems = SidebarMenuItems();
  const filteredMenuItems = FilteredMenuItems({ menuItems });

  let visitsSubMenuCreated = false;
  let techsSubMenuCreated = false;
  let clientsSubMenuCreated = false;
  let inventorySubMenuCreated = false;
  let agendaSubMenuCreated = false;
  let indicatorSubMenuCreated = false;
  let equipsSubMenuCreated = false;

  const toggle = () => {
    toggleSidebar();
    if (toggled) {
      collapseSidebar();
    } else {
      collapseSidebar();
    }
  };

  return (
    <Box
      sx={{
        '& .ps-menu-button:hover': {
          background: '#f3f8fb',
        },
        '& .ps-menu-button::active': {
          background: 'black !important',
        },
        '& .ps-sidebar-container': {
          background: '#F5F6F8',
        },
        '& .link-menu-item .ps-menu-label': {
          color: '#4a4a4a',
        },
        '& .link-menu-item.disabled .icon': {
          color: '#4a4a4a',
        },
      }}
    >
      <Sidebar style={{ height: '100vh' }} rtl={false} defaultCollapsed>
        <Menu key="arrow-button">
          <MenuItem
            icon={
              toggled ? (
                <ArrowBackIosOutlinedIcon className="icon" />
              ) : (
                <ArrowForwardIosOutlinedIcon className="icon" />
              )
            }
            onClick={() => {
              toggle();
            }}
            style={{ textAlign: 'center' }}
          ></MenuItem>
        </Menu>
        <Menu key="main-sidebar">
          {filteredMenuItems.map((item, index) => {
            if (item.visitsModule === true && !visitsSubMenuCreated) {
              visitsSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={<NearMeOutlinedIcon className="icon" />}
                  key={index}
                >
                  {filteredMenuItems
                    .filter((item) => item.visitsModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (item.techsModule === true && !techsSubMenuCreated) {
              techsSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={<EngineeringOutlinedIcon className="icon" />}
                >
                  {filteredMenuItems
                    .filter((item) => item.techsModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (item.clientsModule === true && !clientsSubMenuCreated) {
              clientsSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={<MenuBookOutlined className="icon" />}
                >
                  {filteredMenuItems
                    .filter((item) => item.clientsModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (
              item.inventoryModule === true &&
              !inventorySubMenuCreated
            ) {
              inventorySubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={
                    <FontAwesomeIcon icon={faBoxesStacked} className="icon" />
                  }
                >
                  {filteredMenuItems
                    .filter((item) => item.inventoryModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (item.agendasModule === true && !agendaSubMenuCreated) {
              agendaSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={<FontAwesomeIcon icon={faCalendars} className="icon" />}
                >
                  {filteredMenuItems
                    .filter((item) => item.agendasModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (
              item.indicatorModule === true &&
              !indicatorSubMenuCreated
            ) {
              indicatorSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={
                    <FontAwesomeIcon icon={faTableColumns} className="icon" />
                  }
                >
                  {filteredMenuItems
                    .filter((item) => item.indicatorModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (item.equipsModule === true && !equipsSubMenuCreated) {
              equipsSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={<HandymanOutlinedIcon className="icon" />}
                >
                  {filteredMenuItems
                    .filter((item) => item.equipsModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (item.equipsModule === true && !equipsSubMenuCreated) {
              equipsSubMenuCreated = true;
              return (
                <SubMenu
                  label={item.submenutitle}
                  icon={<HandymanOutlinedIcon className="icon" />}
                >
                  {filteredMenuItems
                    .filter((item) => item.equipsModule)
                    .map((item) => (
                      <Link
                        to={item.path}
                        key={item.path}
                        style={item.disabled}
                      >
                        <MenuItem
                          icon={
                            item.midisabled ? (
                              <Badge badgeContent="ℹ️" color="error">
                                {item.icon}
                              </Badge>
                            ) : (
                              item.icon
                            )
                          }
                          className={`link-menu-item ${
                            item.midisabled ? 'disabled' : ''
                          }`}
                          style={
                            toggled
                              ? { paddingLeft: '2rem' }
                              : { paddingLeft: '0.2rem' }
                          }
                        >
                          {item.title}
                        </MenuItem>
                      </Link>
                    ))}
                </SubMenu>
              );
            } else if (
              !item.visitsModule &&
              !item.techsModule &&
              !item.clientsModule &&
              !item.inventoryModule &&
              !item.agendasModule &&
              !item.indicatorModule &&
              !item.equipsModule
            ) {
              return (
                <Link to={item.path} key={item.path} style={item.disabled}>
                  <MenuItem
                    icon={
                      item.midisabled ? (
                        <Badge badgeContent="ℹ️" color="error">
                          {item.icon}
                        </Badge>
                      ) : (
                        item.icon
                      )
                    }
                    className={`link-menu-item ${
                      item.midisabled ? 'disabled' : ''
                    }`}
                  >
                    {item.title}
                  </MenuItem>
                </Link>
              );
            }
          })}
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default NewSidebar;
